import React, { useEffect, useState } from "react";
import { useNavigate  } from "react-router-dom";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { fetchOrganizationDetails } from "../actions";

function OrganizationRedirect(props) {
  const { id } = props;
  const navigate = useNavigate();
  const [lang] = useTranslation("language");
  const [isChange, setIsChange] = useState();
  const [isDelete, setIsDelete] = useState();

  useEffect(() => {
    async function fetchData() {
      let id;
      let url = window.location.href;
      id = unescape(url).split("?orgId=")[1];
      setIsChange(props.isChange);
      setIsDelete(props.isDelete);
    }
    fetchData();
  }, []);

  const changeRoute = (e, page) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    navigate(page);
  };

  return (
    <>
      <div className="back-to mb-3">
        <a
          onClick={(e) => {
            changeRoute(e, "/organizationCustomer");
          }}
          className="btn btn-primary btn-sm"
        >
          {lang("Buttons.backToInquiry")}
        </a>
      </div>
      <div className="title-withbutton">
        <h2>{lang("organizationDetails.organizationCustomerDetails")}</h2>
        <div className="title-right">
          <button
            onClick={(e) => {
              changeRoute(e, `/organizationAttributeChange?orgId=${id}`);
            }}
            className="btn btn-primary btn-sm"
            disabled={id && isChange ? false : true}
          >
            {lang("Buttons.requestAttributeChange")}
          </button>
          <button
            onClick={(e) => {
              changeRoute(e, `/organizationClosure?orgId=${id}`);
            }}
            className="btn btn-primary btn-sm"
            disabled={id && isDelete ? false : true}
          >
            {lang("Buttons.requestClosure")}
          </button>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    details: state.organizationCustomer.orgDetails,
  };
};

export default connect(mapStateToProps, { fetchOrganizationDetails })(
  OrganizationRedirect
);
